export default __webpack_public_path__ + "static/media/NewMicrositeIcon.2eb1b710.svg";